import qs from 'qs';

import {
  fetchApi,
  catchFetchApiError,
  getFetchApiJSONResponse,
  transformKeysToCamelCase,
} from 'shared/functions';
import { notificationsCentre } from '../constants/apiUrls/notificationsCentre';
import { typesIds } from '../constants/types';

export const notificationsLimit = 25;

export const fetchNotifications = ({ page = 1, limit = 25 } = {}) => {
  const params = {
    page,
    limit,
  };

  return fetchApi(
    `${notificationsCentre.notifications}/?${qs.stringify(params)}`,
    {},
    [],
    false,
    false,
  )
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const fetchUserNotifications = ({ page = 1, limit = 25, filter, sort, dir } = {}) => {
  const params = {
    page,
    limit,
    filter,
    sort,
    dir,
  };

  return fetchApi(
    `${notificationsCentre.userNotifications}?${qs.stringify(params)}`,
    {},
    [],
    false,
    false,
  )
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const updateNotification = ({ id, data } = {}) => {
  const params = {
    method: 'PUT',
    body: JSON.stringify(data),
  };

  return fetchApi(`${notificationsCentre.notifications}/${id}`, params, [], false, false)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const fetchUserNotificationsWhatsNew = (/* {
  page = 1,
  limit = 25,
  filter,
  sort,
  dir,
} = {} */) => {
  /* const params = {
    page,
    limit,
    filter,
    sort,
    dir,
  }; */
  const hardCodedMsg = () => {
    const mockedCreCmbsRelease = {
      _id: 'mock-cre-cmbs',
      headline: 'What’s new – CRE Loan and CMBS Scorecard',
      text: `We are pleased to announce the following enhancements to this Scorecard: 
      
      • Wider scope of application: Besides from assessing single CRE loans, the Scorecard will now also support the assessment of securitisations of CRE loans, i.e. commercial mortgage-backed securities (CMBSs), collateralised loan obligations (CRE CLOs), asset-backed securities (CRE loan ABSs), CRE debt funds or similar CRE debt structures. 
      
      We refer to these jointly as CRE instruments and use CMBSs when referring to specific analytical elements which apply to securitisation only. Accordingly, we are renaming the product to “CRE loan and CMBS Scorecard” and have updated the Product Terms and Conditions accordingly. 
      
      • Modelling undrawn loan parts: The new feature enables the modelling of drawdowns of loan parts which were not yet outstanding as of the model’s cut-off date (undrawn part). 
      
      • Improved workflow on ScopeOne:  We have added an additional “transaction” layer to the assessment workflow. It allows “projects” to be linked to a specific “transaction”. Previously different projects were assessed separately as separate transactions, though they could belong to one and the same transaction in reality. For example, now the user can create a Transaction A and then a project can be associated with it, e.g. Project 1: Initial assessment, Project 2: Monitoring, etc. 
      
      A transaction is defined by its type (CRE or CMBS), the main asset type (e.g. Retail , Office etc.) and the main location of the assets (country: e.g. Germany, Canada, UK etc). Every project has to be linked to a transaction. Thus, naturally every new assessment starts with the creation of a transaction. 
      
      • General improvements: Besides the new features, some new validation rules were introduced, and minor fixes have been made, which reduce the possibility of errors, increase stability of the CRE loan and CMBS Scorecard and improve the user experience.
      
      If you work on CRE loans and/or CMBS, please contact our Service Centre to schedule a demonstration of the CRE loan and CMBS Scorecard with our specialists. Free Trials are available for those that are interested.  `,
      date: '2023-10-24T00:00:00',
      is_read: true,
      is_favourite: false,
      type: {
        category: 'whats_new',
      },
      img_url: '/ca/images/whats-new-cre-cmbs.jpg',
    };

    const mockedEsgImpactReviewRelease = {
      _id: 'mock-esg-impact-review-and-scopeone-api',
      headline: 'What’s new – ESG Impact Review updates and ScopeOne API',
      text: `We are excited to announce our most recent enhancements on ScopeOne:
        
      1) Financial institutions downstream - We have enhanced the ESG Impact Review footprint analysis for financial institutions by adding a downstream feature offering a unique analytical view on the impact of their lending portfolios. ESG Impact Review provides independent and absolute ESG impact scores, including monetised footprint, on corporates and financial institutions globally down to scope-3 level.
  
      2) ESG Impact Review - ESG Impact Review now comes with a database of ESG Impact Reviews on 35,000+ public corporates and financial institutions, which is a significant enlargement from the 13,000+ ESG Impact Reviews on entities we had previously.
  
      3) We have updated our ScopeOne API.
  
        • The ScopeOne API is our primary interface to access and download data in bulk.
        • Whenever you licence a product on ScopeOne, you may want to download and use the related analytical data in-house on a regular basis. 
      `,
      date: '2021-02-17T00:00:00',
      is_read: true,
      is_favourite: false,
      type: {
        category: 'whats_new',
      },
      img_url: '/ca/images/whats-new-esg-impact-review-and-scopeone-api.jpg',
    };

    const mockedPageOneRelease = {
      _id: 'mock-page-one-release',
      headline: "What's new - PageOne",
      text: `We have introduced PageOne - 
      a new landing page for ScopeOne and dedicated pages for our three main areas of interest – Credit, ESG and Funds. 
      Our users benefit from: 
      
      • Improved navigation – An easier, more intuitive navigation panel, which lets you navigate by area of interest: Credit, ESG and Funds (Funds coming soon) 
      • Dedicated ESG section – An entire section dedicated to finding ESG-related insights.
      • Design refresh – The layout has been improved for a fresher look and feel, making it easier for you to find what you are looking for and for us to add features and functionality in the future. 
      
      Please contact our Service Centre if you’d like to set-up a brief virtual training. 
`,
      date: '17/02/2022',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/new-notification.jpg',
      view: false,
    };

    const mockedPortfolioUpdatesNotification = {
      _id: 'mock-portfolio-updates',
      headline: "What's new - Porftolio updates",
      text: `We have updated the Portfolio tool to now display changes of ratings and scores in the "Activity" column allowing users to monitor the entities in their portfolios.

      Additionally, users are now able to add Events to their portfolios. After adding events to a portfolio, users can easily access the recordings of these events where available.
      
      The latest release also included various bug fixes.
      
      If you want to know more about new or existing features or want to give feedback on other topics, please contact the Service Center via email, chat or telephone.`,
      date: '19/10/2021',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/whats-new-portfolio-updates.jpeg',
      view: false,
    };

    const mockedCreditSphereNotification = {
      _id: 'mock-credit-sphere',
      headline: "What's new - Credit Sphere",
      text: `We are introducing Credit Sphere on ScopeOne.

        Credit Sphere offers investors and risk managers access to Scope’s official credit ratings providing the below advantages:
        
        • Fair pricing: Our pricing structure is clear. We do not charge for ratings already paid for by the issuer.
        
        • Ease of use: We make it easy for clients to use our credit ratings across their organisations and for any purposes, including trading, research, investing and risk management or for regulatory purposes. 
        
        • European angle: We assess credit risk from a European angle, offering a different perspective to the US CRAs
        
        You have the option to choose between Scope’s official credit ratings in the Europe and Global ex-Europe reference portfolios – on a view-only basis on ScopeOne free of charge  -- or with full access.`,
      date: '30/09/2021',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/whats_new-credit_sphere.jpeg',
      view: false,
    };

    const mockedNewFeaturesInPortfolioManagerNotification = {
      _id: 'mock-new-features-in-pm',
      headline: "What's new - Portfolio feature",
      text: 'We have added the new feature "Portfolios". Users can now add entities, instruments, research, rating news and events to Portfolios.\n\nPortfolios can be created by uploading entities or instruments through an Excel file or by adding items from the search or other lists.\n\nIf you have questions about the new function, do not hesitate to contact us via email or chat.',
      date: '20/08/2021',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/new-notification-portfolio-manager.jpeg',
      view: false,
    };

    const mockedRebrandDossierToPortfolioNotification = {
      _id: 'mock-rebrand-dossier-to-portfolio',
      headline: "What's new - Portfolio feature",
      text: 'We will be introducing Porfolio as a new feature on ScopeOne soon. In a first step, we have rebranded the Dossier feature to "Portfolio".\n\nIn the next release we will consolidate the portfolio management and upload in one component. This will improving usability and extending functionality for the ScopeOne users.',
      date: '08/07/2021',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/new-notification-rebrand-dossier-to-portfolio.jpg',
      view: false,
    };

    const mockedEventsNotification = {
      _id: 'mock-events',
      headline: "What's new - Event Updates now available in ScopeOne",
      text: 'Find out about the latest Industry Events and register to attend.',
      date: '10/01/2021',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/new-notification-events.jpg',
      view: true,
      viewLink: '/ca/events',
    };

    const mockedNotification = {
      _id: 'mock',
      headline: "What's new - product updates in ScopeOne",
      text: 'In this section you will find the latest updates on products and features delivered through ScopeOne.',
      date: '01/11/2020',
      isRead: true,
      favourite: false,
      accept: false,
      type: {
        category: typesIds.whatsNew,
      },
      img_url: '/ca/images/new-notification.jpg',
      view: false,
    };

    return [
      mockedCreCmbsRelease,
      mockedEsgImpactReviewRelease,
      mockedPageOneRelease,
      mockedPortfolioUpdatesNotification,
      mockedCreditSphereNotification,
      mockedNewFeaturesInPortfolioManagerNotification,
      mockedRebrandDossierToPortfolioNotification,
      mockedEventsNotification,
      mockedNotification,
    ];
  };

  // return Promise.resolve(hardCodedMsg());
  return hardCodedMsg();
  // TODO: Use when the endpoint is ready
  /* return fetchApi(
    `${notificationsCentre.userNotificationsWhatsNew}?${qs.stringify(params)}`,
    {},
    [],
    false,
    false,
  )
    .then(getFetchApiJSONResponse)
    .then(hardCodedMsg)
    .catch(catchFetchApiError)
    .catch(hardCodedMsg); */
};

export const updateNotifications = ({ data } = {}) => {
  const params = {
    method: 'PUT',
    body: JSON.stringify(data),
  };

  return fetchApi(notificationsCentre.notifications, params, [], false, false)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const updateNotificationsSettings = ({ data } = {}) => {
  const params = {
    method: 'PUT',
    body: JSON.stringify(data),
  };

  return fetchApi(notificationsCentre.notificationsSettings, params, [], false, false)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);
};

export const fetchUserNotificationsSettings = () =>
  fetchApi(notificationsCentre.notificationsUserSettings, {}, [], false, false)
    .then(getFetchApiJSONResponse)
    .catch(catchFetchApiError);

export const fetchNotificationsWidget = () =>
  fetchApi(notificationsCentre.notificationsWidget, {}, [], false, false)
    .then(getFetchApiJSONResponse)
    .then(transformKeysToCamelCase)
    .catch(catchFetchApiError);

export const useFetchNotifications = () => {
  return (page, filter) => {
    const allCategory = [
      'account_notification',
      'system_update',
      'response',
      'downloads',
      'uploads',
    ];
    const downloadsCategory = ['downloads'];
    const uploadsCategory = ['uploads'];

    const categoryFilter = () => {
      if (filter.type === 'download') return downloadsCategory;
      if (filter.type === 'upload') return uploadsCategory;
      return allCategory;
    };

    const favFilter = filter.type === 'favourites' ? { is_favourite: true } : {};
    const resFilter = filter.type === 'responses' ? { response: true } : {};

    const params = {
      page,
      limit: notificationsLimit,
      filter: JSON.stringify([
        {
          ...favFilter,
          ...resFilter,
          'type.category': {
            $in: categoryFilter(),
          },
        },
      ]),
    };

    return fetchApi(
      `${notificationsCentre.userNotifications}?${qs.stringify(params)}`,
      {},
      [],
      false,
      false,
    )
      .then(getFetchApiJSONResponse)
      .catch(catchFetchApiError);
  };
};
